import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <h2>About Belah</h2>
      <p>
        Belah is an online store offering a changing selection of fragrances, accessories, beauty, and other products.
        Owned by a young black female entrepreneur, Belah Hair Studio and Accessories is based in Benoni and Giyani.
        Our mission is to provide high-quality products that meet the diverse needs of our customers.
      </p>
      <p>
        Our product range includes:
      </p>
      <ul>
        <li>Fragrances</li>
        <li>Beauty products</li>
        <li>Hair weaves and extensions</li>
        <li>Smartphones</li>
        <li>Shoes and sandals</li>
        <li>Fashion accessories</li>
        <li>Clothing</li>
        <li>Watches</li>
      </ul>
      <p>
        We believe in empowering our customers by providing top-notch products at competitive prices.
        Our commitment to excellence and customer satisfaction is what drives us every day.
      </p>
      <p>
        Thank you for choosing Belah. We look forward to serving you!
      </p>
    </div>
  );
};

export default AboutPage;
